<template>
  <span>
    {{ $n(Number(value), "currency", currency) }}
  </span>
</template>

<script lang="ts">
export type CurrencyFormatterProps = {
  currency: string;
  value: number;
};
</script>

<script lang="ts" setup>
defineProps<CurrencyFormatterProps>();
</script>
